import store from '@/store/index.js';
import { staffsByGroupStatus, staffsByGroupMessageTime, getStaff, devicesByGroupStatus, getDevice, messageReadStatusByUserAndStaff } from './queries';
import { createMessageReadStatus, updateMessageReadStatus } from '@/store/mutations';
import { messageReadStatusbyGroupAndUser } from '@/graphql/queries';
import moment from 'moment-timezone';
import { isAfterDateTime } from '@/utilities/getDate'
import { mixinMethods } from '@/main'
import { Storage } from 'aws-amplify'

const limitMessages = () => mixinMethods.isMobileDevice() ? 1 : 10;
const START_DATE = moment( new Date(2022, 10, 15, 0, 0, 0) );

let loading = false

export async function loadMessageReadByGroup() {
  const { userInfo } = store.state;
  const userID = userInfo.id;
  const input = {
    group: userInfo.tenant.group,
    userID: { eq: userID }
  };

  let listRecords = await mixinMethods.gLoadListAll(messageReadStatusbyGroupAndUser, input, 'messageReadStatusbyGroupAndUser')
  return listRecords;
}

export async function loadStaff() {
  if(loading) return
  loading = true
  const { userInfo, subscriptionStore } = store.state;
  subscriptionStore.messengerList.lastRenderKey = 0 //to show spinloader in messenger list
  if(!userInfo?.tenant?.group) return
  const oneMonthsAgo = new Date();
  oneMonthsAgo.setMonth(oneMonthsAgo.getMonth() - 1);
  let input = {
    group: userInfo.tenant.group,
    sortDirection: "DESC",
    sortDirectionMessage: "DESC",
    filterMessage: {
      messageType: { eq: "messenger" },
      channelType: { eq: "RESPONSE" },
      senderId: { attributeExists: false }
    },
    createdAtFilter: { ge: oneMonthsAgo.toISOString() },
    limit: 1000,
    limitMessages:limitMessages(),
  }
  let listStaff = await mixinMethods.gLoadListAll(staffsByGroupMessageTime, input, 'staffsByGroupMessageTime');
  loading = false
  return Array.isArray(listStaff) ? listStaff : [];
}

export async function loadDevice() {
  const { userInfo } = store.state;
  if(!userInfo?.tenant?.group) return
  let input = {
    group: userInfo.tenant.group,
    sortDirectionMessage: "DESC",
    filterMessage: {
      messageType: { eq: "messenger" },
      channelType: { eq: "RESPONSE" },
      senderId: { attributeExists: false }
    },
    limit: 100,
    limitMessages:limitMessages(),
  }
  let listDevice = await mixinMethods.gLoadListAll(devicesByGroupStatus, input, 'devicesByGroupStatus');
  return Array.isArray(listDevice) ? listDevice : [];
}

export function isVisitedChat( staff ) {
  const { userInfo } = store.state;
  const { items = [] } = staff?.messageReadStatus || {};
  const recordVisit = items.find( recordVisit => recordVisit.userID === userInfo.id );
  return recordVisit;
}

export function haveMessagesSend( staff ) {
  const { items } = staff?.messages || {};
  return items?.length > 0;
}

export function compareLastVisitChatByUser( staff, staffChatVisited ) {
  const lastDateMessageSendByStaff = staff.messages.items[0].createdAt;
  const lastDateVisitByUser = staffChatVisited.readUpToDateTime;
  const readChat = isVisitChatAfterLastMessage( lastDateVisitByUser, lastDateMessageSendByStaff );
  return readChat;
}

export function isVisitChatAfterLastMessage( lastDateVisitByUser, lastDateMessageSendByStaff ) {
  return lastDateVisitByUser === lastDateMessageSendByStaff || isAfterDateTime(lastDateVisitByUser, lastDateMessageSendByStaff)
}

export function countMessagesUnread( staff, lastVisit ) {
  const messages = haveMessagesSend( staff ) ? staff.messages.items : [];
  const newMessages = messages.filter( ({ createdAt }) => !isVisitChatAfterLastMessage( lastVisit , createdAt ) )
  return newMessages.length;
}

const getUpdateSearchKeyFunction = function(chat){
  if (chat.type === 'device') {
    return ()=>{
      const { carrier = '', deviceName = '', deviceLastMessage = '' } = chat.obj || {}
      chat.searchKey = (carrier + ' ' + deviceName + ' ' + deviceLastMessage).toLowerCase().replace(/\s+/,' ')
    }
  } else {
    return ()=>{
      const { firstName = '', lastName = '', smsLastMessage = '' } = chat.obj || {}
      chat.searchKey = (lastName + ' ' + firstName + ' ' + lastName + ' ' + smsLastMessage).toLowerCase().replace(/\s+/,' ')
    }
  }

}

const getUpdateSmsLastMessageFunction = function(chat){
  return (message)=>{
    const associate = chat.obj
    if(message){
      if(message.bodyText){
        associate.smsLastMessage = message.bodyText
        chat.updateSearchKey()
      }else if(message.attachment?.id){
        const timestamp = message.createdAt
        new Promise(async resolve =>{
          const input = {
            id: chat.obj.id
          }
          chat.timeout = setTimeout(async () => {
            if(chat.obj.smsLastMessageTimestamp !== timestamp){
              resolve(null)
            }else{
              resolve(await mixinMethods.api(getStaff, input))
            }
          }, 2000) //sleep
        }).then( response =>{
          if(response?.data?.getStaff){
            associate.smsLastMessage = response.data.getStaff.smsLastMessage
            chat.updateSearchKey()
          }
        })
      }
      if(message.createdAt){
        associate.smsLastMessageTimestamp = message.createdAt
        chat.smsLastMessageTime = new Date(message.createdAt).getTime()
      }
    }else{
      chat.smsLastMessageTime = associate.smsLastMessageTimestamp ? new Date(associate.smsLastMessageTimestamp).getTime() : null
      chat.updateSearchKey()
    }
  }
}

const getUpdateDeviceSmsLastMessageFunction = function(chat){
    return (message)=>{
      const device = chat.obj
      if(message){
        if(message.bodyText){
          device.deviceLastMessage = message.bodyText
          chat.updateSearchKey()
        }else if(message.attachment?.id){
          const timestamp = message.createdAt
          new Promise(async resolve =>{
            const input = {
              id: chat.obj.id
            }
            chat.timeout = setTimeout(async () => {
              if(chat.obj.deviceLastMessageTimestamp !== timestamp){
                resolve(null)
              }else{
                resolve(await mixinMethods.api(getDevice, input))
              }
            }, 2000) //sleep
          }).then( response =>{
            if(response?.data?.getDevice){
              device.deviceLastMessage = response.data.getDevice.deviceLastMessage
              chat.updateSearchKey()
            }
          })
        }
        if(message.createdAt){
          device.deviceLastMessageTimestamp = message.createdAt
          chat.smsLastMessageTime = new Date(message.createdAt).getTime()
        }
      }else{
        chat.smsLastMessageTime = device.deviceLastMessageTimestamp ? new Date(device.deviceLastMessageTimestamp).getTime() : null
        chat.updateSearchKey()
      }
    }
}

export const updateAssociateMessengerPhotoUrl = function(associate = {}){
  const messengerLookupMap = store.getters["subscriptionStore/getMessengerLookupMap"]
  const chat = messengerLookupMap[associate?.id]
  if(chat){
    if(chat.lastAssociatePhoto === associate.photo) return
    chat.lastAssociatePhoto = associate.photo
    Storage.get(associate.photo).then(url=>{
      chat.photoUrl = url
    }).catch(mixinMethods.printUserError)
  }
}

export function getMessengerAssociateList( staffs, staffsUnreadMessages ) {
  const associateLookupMap = store.getters["subscriptionStore/getAssociateLookupMap"]
  const messengerLookupMap = store.getters["subscriptionStore/getMessengerLookupMap"]
  
  // Build message metadata map from query results
  const messageMetadataMap = new Map()
  if (staffs && Array.isArray(staffs)) {
    staffs.forEach(staff => {
      messageMetadataMap.set(staff.id, staff)
    })
  }
  
  // Iterate ALL associates
  const withMessages = []
  const withoutMessages = []
  
  Object.values(associateLookupMap).forEach(associate => {
    const staff = messageMetadataMap.get(associate.id)
    const existingChat = messengerLookupMap[associate.id]
    
    let messageUnread = 0
    let readChat = true
    
    // Only calculate unread if staff has messages
    if (staff) {
      const staffVisited = isVisitedChat(staff)
      const haveMessages = haveMessagesSend(staff)
      
      if (staffsUnreadMessages && typeof staffsUnreadMessages === 'object' && staffsUnreadMessages[staff.id] !== undefined) {
        messageUnread = staffsUnreadMessages[staff.id]
        readChat = messageUnread === 0
      } else if (staffVisited) {
        messageUnread = countMessagesUnread(staff, staffVisited.readUpToDateTime)
        readChat = haveMessages ? compareLastVisitChatByUser(staff, staffVisited) : true
      } else {
        messageUnread = staff.messages.items?.length || 0;
        readChat = messageUnread <= 0;
      }
      
    associate.smsLastMessageTimestamp = staff.smsLastMessageTimestamp
    associate.smsLastMessage = staff.smsLastMessage
    }
    
    let chat
    if (existingChat) {
      chat = existingChat
      chat.readChat = readChat
      chat.messageUnread = messageUnread
    }else{
      chat = {
        id: associate.id,
        readChat,
        messageUnread,
        obj: associate,
        smsLastMessageTime: associate.smsLastMessageTimestamp ? new Date(associate.smsLastMessageTimestamp).getTime() : null,
        lastMomentReceived: ' ',
        searchKey: (associate.lastName + ' ' + associate.firstName + ' ' + associate.lastName + ' ' + (associate.smsLastMessage || '')).toLowerCase().replace(/\s+/, ' '),
        photoUrl: '',
        type: 'staff',
        staffId : associate.id,
        deviceId : ''
      }
      chat.updateSearchKey = getUpdateSearchKeyFunction(chat)
      chat.updateSmsLastMessage = getUpdateSmsLastMessageFunction(chat)
    }
    
    // Prioritize staff with messages
    if (staff) {
      withMessages.push(chat)
    } else {
      withoutMessages.push(chat)
    }
  })
  
  loading = false
  return [...withMessages, ...withoutMessages]
}
export function getMessengerDeviceList( devices, staffsUnreadMessages ) {
  const messenger = []
  const deviceLookupMap = store.getters["subscriptionStore/getDeviceLookupMap"]
  const messengerLookupMap = store.getters["subscriptionStore/getMessengerLookupMap"]

  if(!devices || !Array.isArray(devices)) return messenger

  devices.forEach( device => {
    const associateDevice = deviceLookupMap[device.id]
    if(!associateDevice) return

    const deviceVisited = isVisitedChat( device );
    const haveMessages = haveMessagesSend( device );
    let messageUnread = 0;
    let readChat = false;
    
    // Use API data if available (same logic as staff)
    if (staffsUnreadMessages && typeof staffsUnreadMessages === 'object' && staffsUnreadMessages[device.id] !== undefined) {
      messageUnread = staffsUnreadMessages[device.id];
      readChat = messageUnread === 0;
    } else if (Array.isArray(staffsUnreadMessages) && staffsUnreadMessages.length) {
      // Fallback for old array format
      messageUnread = staffsUnreadMessages.filter(unreadMessage => unreadMessage.deviceId == device.id).length;
      readChat = !messageUnread;
    } else {
      // Existing fallback logic when no API data
      if ( deviceVisited ) {
        messageUnread = countMessagesUnread( device, deviceVisited.readUpToDateTime );
        readChat = haveMessages ? compareLastVisitChatByUser( device, deviceVisited ) : true;
      } else{
        messageUnread = device.messages.items?.length || 0;
        readChat = messageUnread <= 0;
      }
    }

    const existingChat = messengerLookupMap[device.id]

    if(associateDevice) {
    associateDevice.deviceLastMessageTimestamp = device.deviceLastMessageTimestamp
    associateDevice.deviceLastMessage = device.deviceLastMessage
    }

    let chat
    if(existingChat){
      chat = existingChat
      chat.readChat = readChat
      chat.messageUnread = messageUnread
    }else{
      chat = {
        id: device.id,
        readChat,
        messageUnread,
        obj: associateDevice,
        smsLastMessageTime: associateDevice.deviceLastMessageTimestamp ? new Date(associateDevice.deviceLastMessageTimestamp).getTime() : null,
        lastMomentReceived: ' ',
        searchKey: (associateDevice.carrier + ' ' + associateDevice.deviceName + ' ' + associateDevice.deviceLastMessage).toLowerCase().replace(/\s+/,' '),
        photoUrl: '',
        type: 'device',
        deviceId : associateDevice.id,
        staffId : ''
      }
      chat.updateSearchKey = getUpdateSearchKeyFunction(chat)
      chat.updateDeviceLastMessage = getUpdateDeviceSmsLastMessageFunction(chat)
    }

    messenger.push(chat)
  })
  loading = false
  return messenger
}
export function getMessengerAssociateDeviceList(staffs,devices, staffsUnreadMessages) {
  const messengerAssociateList = getMessengerAssociateList(staffs, staffsUnreadMessages);
  const messengerDeviceList = getMessengerDeviceList(devices, staffsUnreadMessages);
  // Ensure both lists are arrays
  const validMessengerAssociateList = Array.isArray(messengerAssociateList) ? messengerAssociateList : [];
  const validMessengerDeviceList = Array.isArray(messengerDeviceList) ? messengerDeviceList : [];

  return [...validMessengerAssociateList, ...validMessengerDeviceList];
}
function isMessageSentFromStartDate( message, startDate ) {
  const { createdAt: messageCreateAt } = message;
  const status = isVisitChatAfterLastMessage( messageCreateAt, startDate);
  return status;
}

export function messageSentLastMonth( listMessages ) {
  return listMessages.filter( message => isMessageSentFromStartDate( message, START_DATE ) );
}

function accumulatorUnreadMessages( prev, next) {
  const { messageUnread, readChat } = next;
  let sumUnreadMessages = readChat ? 0 : prev + messageUnread;
  return sumUnreadMessages;
}

export function totalUnreadMessages( staffList ) {
  // Filter out entities with 0 unread messages to match API calculation
  const staffs = staffList.filter( ({ readChat, messageUnread  }) => !readChat && messageUnread > 0  );
  const numberUnreadMessages = staffs.reduce( accumulatorUnreadMessages,  0);
  return numberUnreadMessages;
}

export async function getMessageReadStatusByUserIdAndStaffId(group, staffId, userId) {
  let record = {}
  try {
    const input = { 
      group,
      staffIDUserID: {
        eq: { staffID: staffId, userID: userId }
      }
    }
    const items = await mixinMethods.gLoadListAll(messageReadStatusByUserAndStaff, input, 'messageReadStatusByUserAndStaff')
    record = items[0] || {}
  } catch (error) {
    console.error(error)
  }
  return record
}

export async function markMessageAsRead(group, staffId, userId) {
  try {
    const messageReadStatus = await getMessageReadStatusByUserIdAndStaffId(group, staffId, userId)
    const messageReadStatusId = messageReadStatus.id
    if(messageReadStatusId){
      //update
      const updateRecord = {
        id: messageReadStatusId,
        readUpToDateTime: new Date().toISOString()
      }
      await mixinMethods.api(updateMessageReadStatus, { input: updateRecord })
    }else{
      //create
      const newRecord = {
        group: group,
        readUpToDateTime: new Date().toISOString(),
        userID: userId,
        staffID: staffId,
        deviceID: "NONE",
      }
      await mixinMethods.api(createMessageReadStatus, { input: newRecord } )
    }
  } catch (error) {
    console.error(error)
  }
}

/**
 * Get unread messages data from the new API endpoint
 * @param {string} group - The group ID
 * @returns {Promise<Object>} - API response with unread message counts
 */
export async function getUnreadMessagesFromAPI(group) {
  try {
    const { API } = await import('aws-amplify');
    const response = await API.get('messages', `/get-staffs-unread-messages/${group}`);
    if (response.success) {
      return {
        totalUnreadMessages: response.totalUnreadMessages || 0,
        staffUnreadCounts: response.staffUnreadCounts || {},
        detailedData: response.detailedData || []
      };
    }
    return { totalUnreadMessages: 0, staffUnreadCounts: {}, detailedData: [] };
  } catch (error) {
    console.error('Error fetching unread messages from API:', error);
    return { totalUnreadMessages: 0, staffUnreadCounts: {}, detailedData: [] };
  }
}
